import React, { useEffect, useRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import SearchSelect from "components/common/SearchSelect";
import Spinner from "components/common/Spinner";
import {
    profileGetTravelInfo,
    profileSetTravelInfo,
} from "api/menu/profile/actions";
import {
    fetchCities
} from "api/menu/master-files/locations/actions";

const TabTravelPreferences = (props) => {
    const {
        setUnsaved,
        travelPreferences,
        profileGetTravelInfo,
        profileSetTravelInfo,
        loading,

        fetchCities,
        provinces,
        cities,
    } = props;

    const simpleValidator = useRef(new SimpleReactValidator({
        locale: "en",
        element: message => <div className="text-danger">{message}</div>
    }));

    const [userTravelPreferences, setUserTravelPreferences] = useState(travelPreferences);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [selectedCities, setSelectedCities] = useState([]);


    const handleSave = (data) => {
        if (simpleValidator.current.allValid()) {
            /*
            const userTravelPreferencesForSave = Object.assign({}, data);
            userTravelPreferencesForSave.travelCities = selectedCities.map(item => {
                const data = {
                    city: item.label,
                    cityId: item.value,
                    province: item.province,
                    provinceId: item.provinceId,
                };

                if (item.id) {
                    data.id = item.id;
                }

                return data;
            });
            profileSetTravelInfo(userTravelPreferencesForSave);
            */
            profileSetTravelInfo(data);
            setUnsaved(false);
        }
    };

    const onChange = (arr) => {
        const newUserTravelPreferences = Object.assign({}, userTravelPreferences);
        arr.forEach(item => {
            newUserTravelPreferences[item.key] = item.value;
        });
        setUserTravelPreferences(newUserTravelPreferences);
        setUnsaved(() => handleSave(newUserTravelPreferences));
    };

    const handleChangeCities = (options) => {
        setSelectedCities(options);
        const newUserTravelPreferences = Object.assign({}, userTravelPreferences);
        newUserTravelPreferences.travelCities = options.map(item => {
            const data = {
                city: item.label,
                cityId: item.value,
                province: item.province,
                provinceId: item.provinceId,
            };

            if (item.id) {
                data.id = item.id;
            }

            return data;
        });
        setUserTravelPreferences(newUserTravelPreferences);
        setUnsaved(() => handleSave(newUserTravelPreferences));
    };

    useEffect(() => {
        profileGetTravelInfo();
    }, [profileGetTravelInfo]);

    useEffect(() => {
        setUserTravelPreferences(travelPreferences);

        const travelCities = (travelPreferences.travelCities
            ? travelPreferences.travelCities
            : []);
        const newCities = travelCities.map(item => ({
                value: item.cityId,
                label: item.city,
                province: item.province,
                provinceId: item.provinceId,
            }));
        setSelectedCities(newCities);
    }, [travelPreferences]);

    const provincesOptions = provinces.map(value => ({
            value: parseInt(value.id, 10),
            label: value.fullName
        })),
        citiesOptions = cities.map(value => ({
            value: parseInt(value.id, 10),
            label: value.name,
            province: selectedProvince ? selectedProvince.label : null,
            provinceId: selectedProvince ? selectedProvince.value : null,
        }));

    return (
        <div className="position-relative py-4">
            {!loading || <Spinner />}

            <div className="align-items-center d-flex form-group form-inline">
                <label className="mr-5">Do you have access to a vehicle and a valid drivers licence?</label>
                <div className="mt-0 mr-3 form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="driver-license-yes"
                        checked={!!userTravelPreferences.hasCar}
                        onChange={() => {
                            onChange([{
                                key: "hasCar",
                                value: true
                            }]);
                        }}
                    />
                    <label className="form-check-label" htmlFor="driver-license-yes">
                        Yes
                    </label>
                </div>
                <div className="mt-0 mr-3 form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="driver-license-no"
                        checked={!userTravelPreferences.hasCar}
                        onChange={() => {
                            onChange([{
                                key: "hasCar",
                                value: false
                            }]);
                        }}
                    />
                    <label className="form-check-label" htmlFor="driver-license-no">
                        No
                    </label>
                </div>
            </div>

            <div className="mt-4 mb-2">I'm available to travel...</div>
            <div className="form-group form-inline px-4">
                <label>a maximum of</label>
                <input
                    className="form-control mx-2"
                    type="number"
                    value={userTravelPreferences.maximumTravelDistance || 0}
                    onChange={ev => {
                        onChange([{
                            key: "maximumTravelDistance",
                            value: ev.target.value
                        }]);
                    }}
                />
                <label>km from my location</label>
            </div>

            <div className="mt-4 mb-2">And to any of the following location(s)</div>
            <div className="row">
                <div className="col-4">
                    <SearchSelect
                        className="custom-react-select"
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        options={provincesOptions}
                        value={selectedProvince}
                        onChange={option => {
                            setSelectedProvince(option);
                            fetchCities(option.value);
                        }}
                    />
                </div>
                <div className="col-8">
                    <SearchSelect
                        className="custom-react-select"
                        isLoading={false}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={true}
                        options={citiesOptions}
                        value={selectedCities}
                        onChange={options => handleChangeCities(options)}
                    />
                </div>
            </div>
            <div className="form-group form-inline mt-2">
                <label>Ideally I'd like to only travel</label>
                <input
                    className="form-control mx-2"
                    type="number"
                    value={userTravelPreferences.preferedTravelDistance || 0}
                    onChange={ev => {
                        onChange([{
                            key: "preferedTravelDistance",
                            value: ev.target.value
                        }]);
                    }}
                />
                <label>km from my location</label>
            </div>

            <div className="text-right">
                <button
                    className="btn btn-success"
                    onClick={() => handleSave(userTravelPreferences)}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.profile.loading,
    travelPreferences: state.profile.travelPreferences,

    provinces: state.locations.provinces,
    cities: state.locations.cities,
});

const mapStateToDispatch = dispatch => ({
    profileGetTravelInfo: bindActionCreators(profileGetTravelInfo, dispatch),
    profileSetTravelInfo: bindActionCreators(profileSetTravelInfo, dispatch),

    fetchCities: bindActionCreators(fetchCities, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabTravelPreferences);
